import { useState } from 'react';
import { BellPlus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip';
import ReportsDialog from '@/components/reports/ReportsDialog';
import { useFeatures } from '@/hooks/useFeatures';

// The "make it recurring" chip: appears under chat answers (flag-gated) and
// opens the scheduled-reports popup with the user's question pre-filled.
interface Props {
  question: string;
}

export default function ScheduleReportButton({ question }: Props) {
  const { features, loading } = useFeatures();
  const [open, setOpen] = useState(false);

  const enabled = !loading && !!features.scheduled_reports;
  if (!enabled || !question.trim()) return null;

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setOpen(true)}
            className="text-muted-foreground"
            aria-label="Schedule as recurring report"
          >
            <BellPlus className="!size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Schedule this question as a recurring email report</TooltipContent>
      </Tooltip>
      {open ? (
        <ReportsDialog
          open={open}
          onOpenChange={setOpen}
          initialQuestion={question}
        />
      ) : null}
    </>
  );
}
